(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tg-dust-pdp"] && !Shopify.designMode) return;
  try {
    (() => {
  function init() {
    const intro = document.querySelector('[data-tg-dust-pdp]');
    if (!intro) return;
    const root = intro.closest('.tg-dust-pdp');
    const formatter = new Intl.NumberFormat(intro.dataset.locale || 'en-GB', {style: 'currency', currency: intro.dataset.currency || 'GBP'});
    let queued = false;
    function update() {
      queued = false;
      root.querySelectorAll('.template_6_block__cb').forEach(card => {
        const radio = card.querySelector('input.prvw_pair');
        const unit = card.querySelector('[id^="prvw_totalAmount"]');
        const title = card.querySelector('h5');
        const content = card.querySelector('.template_6_block__cbmain--content--right');
        if (!radio || !unit || !content) return;
        const quantity = Number(radio.value);
        if (!Number.isInteger(quantity) || quantity < 1) return;
        const jarTitle = quantity + ' ' + (quantity === 1 ? intro.dataset.jar : intro.dataset.jars);
        if (title && title.textContent.trim() !== jarTitle) title.textContent = jarTitle;
        const numberText = unit.textContent.replace(/[^0-9.,]/g, '').replace(/,/g, '');
        const unitPrice = Number(numberText);
        if (!numberText || !Number.isFinite(unitPrice)) return;
        let total = content.querySelector('.tg-dust-bundle-total');
        if (!total) {
          total = document.createElement('div');
          total.className = 'tg-dust-bundle-total';
          total.append(document.createElement('span'), document.createElement('small'));
          content.prepend(total);
        }
        const value = formatter.format(Math.round(unitPrice * 100) * quantity / 100);
        if (total.firstElementChild.textContent !== value) total.firstElementChild.textContent = value;
        if (total.lastElementChild.textContent !== intro.dataset.total) total.lastElementChild.textContent = intro.dataset.total;
      });
    }
    new MutationObserver(() => {
      if (!queued) {
        queued = true;
        requestAnimationFrame(update);
      }
    }).observe(root, {childList: true, subtree: true, characterData: true});
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
  } catch(e) { console.error(e); }
})();

})();
